import React from "react";
import { IconProps } from "./icons.models";

export const DeleteIcon: React.FC<IconProps> = ({
    width = 20,
    height = 20,
    className,
    onClick,
    fillColor = "#FB2C36",
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        onClick={onClick}
    >
        <path d="M2.5 5H17.5" stroke={fillColor} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M15.8332 5V16.6667C15.8332 17.5 14.9998 18.3333 14.1665 18.3333H5.83317C4.99984 18.3333 4.1665 17.5 4.1665 16.6667V5"
            stroke={fillColor}
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.6665 5.0013V3.33464C6.6665 2.5013 7.49984 1.66797 8.33317 1.66797H11.6665C12.4998 1.66797 13.3332 2.5013 13.3332 3.33464V5.0013"
            stroke={fillColor}
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M8.3335 9.16797V14.168" stroke={fillColor} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.6665 9.16797V14.168" stroke={fillColor} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
